/* eslint-disable react/prop-types */
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

// Estado del carrito lateral (panel). Valor por defecto inofensivo por si un componente
// se renderiza fuera del provider.
export const cartDrawerContext = createContext({
    abierto: false,
    abrirCarrito: () => { },
    cerrarCarrito: () => { },
});

export const CartDrawerProvider = ({ children }) => {
    const [abierto, setAbierto] = useState(false);

    const abrirCarrito = useCallback(() => setAbierto(true), []);
    const cerrarCarrito = useCallback(() => setAbierto(false), []);

    const value = useMemo(() => ({ abierto, abrirCarrito, cerrarCarrito }), [abierto, abrirCarrito, cerrarCarrito]);

    return <cartDrawerContext.Provider value={value}>{children}</cartDrawerContext.Provider>;
};

export const useCartDrawer = () => useContext(cartDrawerContext);
